import {
    ActionTypes,
    EmailAnalyticsAction,
    EmailAnalyticsData,
} from './actions';

interface EmailAnalyticsState {
  data: EmailAnalyticsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: EmailAnalyticsState = {
  data: null,
  loading: false,
  error: null,
};

export default function emailAnalyticsReducer(
  state: EmailAnalyticsState = initialState,
  action: EmailAnalyticsAction
): EmailAnalyticsState {
  switch (action.type) {
    case ActionTypes.FETCH_ANALYTICS_REQUEST:
      return { ...state, loading: true, error: null };
    case ActionTypes.FETCH_ANALYTICS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case ActionTypes.FETCH_ANALYTICS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
